<mat-form-field class="full-width">
  <mat-label>{{'TIMEZONE.LABEL' | translate}}</mat-label>
  <input #autoCompleteInput type="text" aria-label="'TIMEZONE.LABEL' | translate" matInput [formControl]="myControl"
    [matAutocomplete]="auto" (click)="clearTemporarily()">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
    (optionSelected)="changeTimezone($event.option.value)" (closed)="onClose()">
    <mat-optgroup [label]="'TIMEZONE.FILTER' | translate">
      @for (option of filteredOptions | async ; track option) {
        <mat-option [value]="option">{{option.display}}</mat-option>
      }
    </mat-optgroup>
  </mat-autocomplete>
</mat-form-field>